import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a223b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = { class: "chat-list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" }, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "username"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "date" }, null, -1))

import { inject, nextTick, ref } from 'vue'
import { ElAvatar, ElScrollbar } from 'element-plus'
import { ChatApi, EmojiApi, InjectionEmojiApi } from '~/index'
import { useEmojiParse } from '~/hooks'

interface Props {
  data: ChatApi[]
  userId: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message',
  props: {
    data: null,
    userId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  data: ChatApi[]
  userId: number
}

const { allEmoji } = inject(InjectionEmojiApi) as EmojiApi



const scrollbarRef = ref()

const scroll = () => {
  nextTick(() => {
    const tar = document.querySelector('.chat-item:last-child') as HTMLDivElement
    scrollbarRef.value.setScrollTop(tar.offsetTop)
  })
}

expose({
  scroll
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElScrollbar), {
      ref_key: "scrollbarRef",
      ref: scrollbarRef
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass([{ self: __props.userId == item.id }, "chat-item"])
            }, [
              _createElementVNode("div", null, [
                _createVNode(_unref(ElAvatar), null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                (__props.userId != item.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.username), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "card-box",
                  innerHTML: _unref(useEmojiParse)(_unref(allEmoji), item.content)
                }, null, 8, _hoisted_6)
              ]),
              _hoisted_7
            ], 2))
          }), 128))
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})